import HistoryDetailGrid from './HistoryDetailGrid';

export default HistoryDetailGrid;
